import { AiContentGenerateEvent } from '@videoblocks/events-ts/lib/storyblocks/content/ai/AiContentGenerateEvent';
import { RequestMethod } from '@videoblocks/events-ts/lib/storyblocks/content/ai/RequestMethodEnum';

import { AiContentEventCommonOptions, buildCommonAiContentEventProperties } from './AiContentEventCommon';

// basically all that is different with the generate factory is the inclusion of the request/response data
export interface AiContentGenerateEventFactoryOptions extends AiContentEventCommonOptions {
    requestUrl: string;
    requestMethod: keyof typeof RequestMethod;
    requestHeaders?: Record<string, string>;
    requestQueryParams?: Record<string, string>;
    requestBody?: string | null;
    responseStatusCode: number;
    responseHeaders?: Record<string, string>;
    responseBody?: string | null;
}

async function create(options: AiContentGenerateEventFactoryOptions): Promise<AiContentGenerateEvent> {
    const {
        requestUrl,
        requestMethod,
        requestHeaders = {},
        requestQueryParams = {},
        requestBody = null,
        responseStatusCode,
        responseHeaders = {},
        responseBody = null,
    } = options;

    const event = new AiContentGenerateEvent();

    const commonProps = await buildCommonAiContentEventProperties(options);
    Object.assign(event, commonProps);

    event.request = {
        url: requestUrl,
        method: RequestMethod[requestMethod],
        headers: requestHeaders,
        queryParams: requestQueryParams,
        body: requestBody,
    };

    event.response = {
        statusCode: responseStatusCode,
        headers: responseHeaders,
        body: responseBody,
    };

    return event;
}

export const AiContentGenerateEventFactory = { create };
